<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 style="margin-bottom: 0px;">DOCUMENTOS</h5>
      <h6 style="margin-top: 0px;">Consulta y gestión del Inventario del Archivo</h6>
    </div>

    <div class="row d-flex">
      
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
          <div class="area">
            <Busqueda v-on:ValorDeConsulta="ObtenDatos($event)" :barCode=this.barraCode :IncidenteCode=this.CodigoARecibir :actualiza=this.ActualizaConsulta />
          </div>
        </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="Documento.BaseDatos!=null">
        <div  v-if="Documento.BaseDatos.BaseDatosId==1"> <!-- Bases de datos Equitas -->
          <div class="area" v-if="Documento.TipoDocumento.TipoDocumentoId==1 && IncidenteInfo==null && TerceriaInfo==null">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div>
              <div class="row align-items-center">
                <div class="form-group col-8" id="Area_div">
                  <label>Área</label>
                  <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Materia_div" v-if="Documento.Materia != null">
                  <label>Materia</label>
                  <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="TipoDocumento_div">
                  <label>Tipo de Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Anio_div">
                  <label>Año</label>

                  <input type="text" class="form-control " v-model="Documento.Anio" readonly />
                </div>
                <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-else>
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-if="Documento.Sufijo!=null">
                  <label>Sufijo</label>
                  <input type="text" class="form-control" v-model="Documento.Sufijo" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro de creación</label>
                  <input type="text" class="form-control" v-model="FechaCreacion" readonly />
                </div>
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro en Archivo</label>
                  <input type="text" class="form-control" v-model="FechaArchivado" readonly/>
                </div>
                <div class="form-group col-4" id="Estatus_div">
                  <label>Estatus del Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoEstatusInventario.Nombre" readonly />
                </div>
              </div>
              <div class="row align-items-center" v-if="Documento.Anexos!=null">
                <div class="form-group col-12" id="TipoDocumento_div">
                  <label>Observaciones y/o Anexos</label>
                  <input type="text" class="form-control" v-model="Documento.Anexos" readonly />
                </div>
              </div>
              <div class="row align-items-center">
                <div class="form-group col-6" id="Sede_div" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                  <label>Sede de resguardo en Archivo</label>
                  <input type="text" class="form-control" v-model="Documento.SedeArchivo.Nombre" readonly />
                </div>
                <div v-else>
                    <input type="text" class="form-control" readonly />
                </div>
                <div class="form-group col-2 text-right" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                  <button class="btn btn-secondary btn-sm" @click='EditaDocumento(Documento.CodigoBarras)'>Cambiar Estatus</button>
                </div>
                <div class="form-group col-2 text-right" v-if="Documento.Referencias.length > 0 && InfoDoc==null" >
                  <button class="btn btn-secondary btn-sm" @click='VerReferencia(Documento.Referencias)' >Mostrar Referencia</button>
                </div>
                <div class="form-group col-2 text-right" v-else-if="InfoDoc!=null">
                  <button class="btn btn-secondary btn-sm" @click='VerInfoDoc()' >Información Documento Principal</button>
                </div>
              </div >
            </div>
            <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
                  <h5>Información del Juicio</h5>
                  <hr>
            </div>
            <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tipo:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Juicio}}</label>
              </div>
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tramite:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Tramite}}</label>
              </div>
            </div>
            <div v-if="Documento.Partes!=null && Documento.Partes.length>0">
              <div>
                <h5>Información de las Partes</h5>
                <hr>
              </div>
              <div id="Partes_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th>Parte</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                      <td>{{parte.Tipo_Parte}}</td>
                      <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if='Documento.InventarioDocumentoId> 0'>
                  <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <h5>Contenido</h5>
                      <hr>
                  </div>
                  <div class="row">
                    <div class="col-9">
                      <h6>Volumenes</h6>
                    </div>
                    <div class="col-3 text-right" v-if="Documento.InventarioDocumentoId > 0 && Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <button class="btn btn-secondary btn-sm" @click='NuevoVolumen(Documento.InventarioDocumentoId, Documento.CodigoBarras)'>Nuevo Volumen</button>
                    </div>
                  </div>
                  <div id="Volumen_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                          <th>Cont.</th>
                          <th>Ubicación</th>
                          <th>Contenido</th>
                          <th>Estatus</th>
                          
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                          <td width="30">{{detalle.NumVolumen}}</td>
                          <td width="40">{{detalle.Fojas}}</td>
                          <td width="40">{{detalle.Contenedor}}</td>
                          <td width="350" v-html="EstatusUbicacionVolumen(detalle)"></td>
                          <!-- <td width="250" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                          <td width="250" v-else>{{detalle.Area.Nombre}}</td> -->
                          <td width="350" v-html="DesglosaContenido(detalle)"></td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                            <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                            <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                            <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          
                          <td width="30">
                            <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarVolumen(detalle.VolumenId, Documento.CodigoBarras)" title="Editar Volumen">
                              <i class="fas fa-pen-square"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                  </div>
                  <div v-if="Documento.Incidentes!=null && Documento.Incidentes.length>0">
                    <div>
                      <h6>Incidentes</h6>
                    </div>
                    <div id="Incidentes_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Incidentes.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                            <td width="50">{{detalle.NumeroIncidente}}</td>
                            <td width="150">{{detalle.TipoIncidente}}</td>
                            <td width="60">{{detalle.Contenedor}}</td>
                            <td width="350" v-html="EstatusUbicacionIncidente(detalle)"></td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(detalle, null)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-if="Documento.Tercerias.length>0">
                    <div>
                      <h6>Tercerías</h6>
                    </div>
                    <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo Terceria</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Tercerias.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                            <td width="50">{{detalle.NumeroTerceria}}</td>
                            <td width="280">{{detalle.TipoTerceria}}</td>
                            <td width="100">{{detalle.Contenedor}}</td>
                            <td width="350" v-html="EstatusUbicacionTerceria(detalle)"></td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(null, detalle)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
            </div>
          </div>
          <div class="area" v-if="Documento.TipoDocumento.TipoDocumentoId==4">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-8" id="Area_div">
                <label>Área</label>
                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="TipoDocumento_div">
                <label>Tipo de Documento</label>
                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Anio_div">
                <label>Año</label>
                <input type="text" class="form-control " v-model="Documento.Anio" readonly />
              </div>
              <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-else>
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-4" id="Registro_div">
                <label>Registro de creación</label>
                <input type="text" class="form-control" v-model="FechaCreacion" readonly />
              </div>

            </div>
            <div class="row align-items-center" v-if="Documento.AmparoDocumentoPrincipal!=null">
              <div class="form-group col-12" id="Estatus_div">
                <label class="text-success"><b>Amparo del Documento {{Documento.AmparoDocumentoPrincipal.TipoDocumento.Nombre}} {{Documento.AmparoDocumentoPrincipal.Consecutivo}}/{{Documento.AmparoDocumentoPrincipal.Anio}} del {{Documento.AmparoDocumentoPrincipal.Area.Nombre}}</b></label>
              </div>
            </div>
            <div>
              <div id="Amparos_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0 && Documento.AmparoDocumentoPrincipal==null">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th>Contenedor</th>
                          <th>Ubicación</th>
                          <th>Estatus</th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                          
                          <td width="50">{{detalle.Contenedor}}</td>
                          <td width="350" v-html="EstatusUbicacionVolumen(detalle)"></td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                            <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                            <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                            <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          
                          <td width="30">
                            <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarVolumen(detalle.VolumenId, Documento.CodigoBarras)" title="Editar Volumen">
                              <i class="fas fa-pen-square"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
              </div>
            </div>
          </div>
          <div class="area" v-if="(Documento.TipoDocumento.TipoDocumentoId==5 || Documento.TipoDocumento.TipoDocumentoId==6 || Documento.TipoDocumento.TipoDocumentoId==11 || Documento.TipoDocumento.TipoDocumentoId==12)">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-8" id="Area_div">
                <label>Área</label>
                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="TipoDocumento_div">
                <label>Tipo de Documento</label>
                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Anio_div">
                <label>Año</label>
                <input type="text" class="form-control " v-model="Documento.Anio" readonly />
              </div>
              <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-else>
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-4" id="Registro_div">
                <label>Registro de creación</label>
                <input type="text" class="form-control" v-model="FechaCreacion" readonly />
              </div>
            </div>
            <div v-if="Documento.Partes!=null && Documento.Partes.length>0">
              <div>
                <h5>Información de las Partes</h5>
                <hr>
              </div>
              <div id="Partes_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th>Parte</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                      <td>{{parte.Tipo_Parte}}</td>
                      <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="area" v-if="IncidenteInfo!=null && (IncidenteInfo.IncidenteId>0 || IncidenteInfo.DocumentoId_Referencia>0)">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Area_div">
                <label>Incidente No:</label>
                <input type="text" class="form-control" v-model="IncidenteInfo.NumeroIncidente" readonly />
              </div>
              <div class="form-group col-8" id="TipoDocumento_div">
                <label>Tipo de Incidente</label>
                <input type="text" class="form-control" v-model="IncidenteInfo.TipoIncidente" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-12" id="Area_div">
                <h6 class="text-success"><b>Incidente del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} del {{Documento.Area.Nombre}}</b></h6>
                
              </div>
            </div>
          </div> 
          <div class="area" v-if="TerceriaInfo!=null && TerceriaInfo.TerceriaId>0">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Area_div">
                <label>Tercería No:</label>
                <input type="text" class="form-control" v-model="TerceriaInfo.NumeroTerceria" readonly />
              </div>
              <div class="form-group col-8" id="TipoDocumento_div">
                <label>Tipo de Tercería:</label>
                <input type="text" class="form-control" v-model="TerceriaInfo.TipoTerceria" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-12" id="Area_div">
                <h6 class="text-success"><b>Tercería del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} del {{Documento.Area.Nombre}}</b></h6>
                
              </div>
            </div>
          </div>
        </div>
        <div v-if="Documento.BaseDatos.BaseDatosId==2 || Documento.BaseDatos.BaseDatosId==3"> <!-- Bases de datos Siop y Majat -->
          <div class="area">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div>
              <div class="row align-items-center">
                <div class="form-group col-8" id="Area_div">
                  <label>Área</label>
                  <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Materia_div" v-if="Documento.Materia != null">
                  <label>Materia</label>
                  <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="TipoDocumento_div">
                  <label>Tipo de Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Anio_div">
                  <label>Año</label>

                  <input type="text" class="form-control " v-model="Documento.Anio" readonly />
                </div>
                <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-else>
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-if="Documento.Sufijo!=null">
                  <label>Sufijo</label>
                  <input type="text" class="form-control" v-model="Documento.Sufijo" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro de creación</label>
                  <input type="text" class="form-control" v-model="FechaCreacion" readonly />
                </div>
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro en Archivo</label>
                  <input type="text" class="form-control" v-model="FechaArchivado" readonly/>
                </div>
                <div class="form-group col-4" id="Estatus_div">
                  <label>Estatus del Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoEstatusInventario.Nombre" readonly />
                </div>
              </div>
              <div class="row align-items-center">
                <div class="form-group col-6" id="Sede_div" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                  <label>Sede de resguardo en Archivo</label>
                  <input type="text" class="form-control" v-model="Documento.SedeArchivo.Nombre" readonly />
                </div>
                <div class="form-group col-6 text-right" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                    <button class="btn btn-secondary btn-sm" @click='EditaDocumento(Documento.CodigoBarras)'>Cambiar Estatus</button>
                </div>
              </div >
            </div>
            <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0">
                  <h5>Información del Juicio</h5>
                  <hr>
            </div>
            <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0">
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tipo:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Juicio}}</label>
              </div>
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tramite:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Tramite}}</label>
              </div>
            </div>
            <div v-if="Documento.Partes!=null && Documento.Partes.length>0">
              <div>
                <h5>Información de las Partes</h5>
                <hr>
              </div>
              <div id="Partes_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th>Parte</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                      <td>{{parte.Tipo_Parte}}</td>
                      <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if='Documento.InventarioDocumentoId> 0'>
                  <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <h5>Contenido</h5>
                      <hr>
                  </div>
                  <div class="row">
                    <div class="col-9">
                      <h6>Volumenes</h6>
                    </div>
                    <div class="col-3 text-right" v-if="Documento.InventarioDocumentoId > 0 && Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <button class="btn btn-secondary btn-sm" @click='NuevoVolumen(Documento.InventarioDocumentoId, Documento.CodigoBarras)'>Nuevo Volumen</button>
                    </div>
                  </div>
                  <div class="row" v-if="Documento.Volumenes!=null && Documento.Volumenes.length>0">
                    <div id="Volumen_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Fojas</th>
                            <th>Contenedor</th>
                            <th>Ubicación</th>
                            <th>Contenido</th>
                            <th>Estatus</th>
                            
                            <th class="text-center"></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Volumenes.length <= 0">
                            <td colspan="12" class="text-center">No hay registro del Volumen</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                            <td width="30">{{detalle.NumVolumen}}</td>
                            <td width="50">{{detalle.Fojas}}</td>
                            <td width="50">{{detalle.Contenedor}}</td>
                            <td width="350" v-html="EstatusUbicacionVolumen(detalle)"></td>
                            <td width="400" v-html="DesglosaContenido(detalle)"></td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarVolumen(detalle.VolumenId, Documento.CodigoBarras)" title="Editar Volumen">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      
                    </div>
                  </div>
                  <div v-if="Documento.Incidentes!=null && Documento.Incidentes.length>0">
                    <div>
                      <h6>Incidentes</h6>
                    </div>
                    <div id="Incidentes_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Incidentes.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                            <td width="50">{{detalle.NumeroIncidente}}</td>
                            <td width="280">{{detalle.TipoIncidente}}</td>
                            <td width="60">{{detalle.Contenedor}}</td>
                            <td width="350" v-html="EstatusUbicacionIncidente(detalle)"></td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(detalle, null)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-if="Documento.Tercerias.length>0">
                    <div>
                      <h6>Tercerías</h6>
                    </div>
                    <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo Terceria</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Tercerias.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                            <td width="50">{{detalle.NumeroTerceria}}</td>
                            <td width="280">{{detalle.TipoTerceria}}</td>
                            <td width="100">{{detalle.Contenedor}}</td>
                            <td width="350" v-html="EstatusUbicacionTerceria(detalle)"></td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(null, detalle)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-else>
        <div > <!-- documento sin referencia -->
          <div class="area" v-if="Documento.TipoDocumento.TipoDocumentoId==1 && IncidenteInfo==null && TerceriaInfo==null">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div>
              <div class="row align-items-center">
                <div class="form-group col-8" id="Area_div">
                  <label>Área</label>
                  <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Materia_div" v-if="Documento.Materia != null">
                  <label>Materia</label>
                  <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="TipoDocumento_div">
                  <label>Tipo de Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                </div>
                <div class="form-group col-4" id="Anio_div">
                  <label>Año</label>

                  <input type="text" class="form-control " v-model="Documento.Anio" readonly />
                </div>
                <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-else>
                  <label>Consecutivo</label>
                  <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
                </div>
                <div class="form-group col-2" id="Consecutivo_div" v-if="Documento.Sufijo!=null">
                  <label>Sufijo</label>
                  <input type="text" class="form-control" v-model="Documento.Sufijo" readonly />
                </div>

              </div>
              <div class="row align-items-center">
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro de creación</label>
                  <input type="text" class="form-control" v-model="FechaCreacion" readonly />
                </div>
                <div class="form-group col-4" id="Registro_div">
                  <label>Registro en Archivo</label>
                  <input type="text" class="form-control" v-model="FechaArchivado" readonly/>
                </div>
                <div class="form-group col-4" id="Estatus_div">
                  <label>Estatus del Documento</label>
                  <input type="text" class="form-control" v-model="Documento.TipoEstatusInventario.Nombre" readonly />
                </div>
              </div>
              <div class="row align-items-center">
                <div class="form-group col-6" id="Sede_div" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                  <label>Sede de resguardo en Archivo</label>
                  <input type="text" class="form-control" v-model="Documento.SedeArchivo.Nombre" readonly />
                </div>
                <div v-else>
                    <input type="text" class="form-control" readonly />
                </div>
                <div class="form-group col-2 text-right" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                  <button class="btn btn-secondary btn-sm" @click='EditaDocumento(Documento.CodigoBarras)'>Cambiar Estatus</button>
                </div>
                <div class="form-group col-2 text-right" v-if="Documento.Referencias.length > 0 && InfoDoc==null" >
                  <button class="btn btn-secondary btn-sm" @click='VerReferencia(Documento.Referencias)' >Mostrar Referencia</button>
                </div>
                <div class="form-group col-2 text-right" v-else-if="InfoDoc!=null">
                  <button class="btn btn-secondary btn-sm" @click='VerInfoDoc()' >Información Documento Principal</button>
                </div>
              </div >
            </div>
            
            <div v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
                  <h5>Información del Juicio</h5>
                  <hr>
            </div>
            <div class="row" v-if="Documento.Juicio!=null && Documento.Juicio.DocumentoId_Referencia >0 && (Documento.TipoDocumento.TipoDocumentoId!=23 && Documento.TipoDocumento.TipoDocumentoId!=24) && (Documento.Area.AreaId!=11 && Documento.Area.AreaId!=12 && Documento.Area.AreaId!=13 && Documento.Area.AreaId!=14 && Documento.Area.AreaId!=15 && Documento.Area.AreaId!=16)">
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tipo:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Juicio}}</label>
              </div>
              <div class="form-group col-1" id="Estatus_div">
                <label><b>Tramite:</b></label>
              </div>
              <div class="form-group col-5" id="Estatus_div">
                <label>{{Documento.Juicio.Tramite}}</label>
              </div>
            </div>
            <div v-if="Documento.Partes!=null && Documento.Partes.length>0">
              <div>
                <h5>Información de las Partes</h5>
                <hr>
              </div>
              <div id="Partes_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th>Parte</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                      <td>{{parte.Tipo_Parte}}</td>
                      <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if='Documento.InventarioDocumentoId> 0'>
                  <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <h5>Contenido</h5>
                      <hr>
                  </div>
                  <div class="row">
                    <div class="col-9">
                      <h6>Volumenes</h6>
                    </div>
                    <div class="col-3 text-right" v-if="Documento.InventarioDocumentoId > 0 && Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4">
                      <button class="btn btn-secondary btn-sm" @click='NuevoVolumen(Documento.InventarioDocumentoId, Documento.CodigoBarras)'>Nuevo Volumen</button>
                    </div>
                  </div>
                  <div id="Volumen_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th>No.</th>
                          <th>Fojas</th>
                          <th>Contenedor</th>
                          <th>Ubicación</th>
                          <th>Contenido</th>
                          <th>Estatus</th>
                          
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                          <td width="30">{{detalle.NumVolumen}}</td>
                          <td width="50">{{detalle.Fojas}}</td>
                          <td width="50">{{detalle.Contenedor}}</td>
                          <td width="250" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                          <td width="250" v-else>{{detalle.Area.Nombre}}</td>
                          <td width="400" v-html="DesglosaContenido(detalle)"></td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                            <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                            <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                            <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          
                          <td width="30">
                            <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarVolumen(detalle.VolumenId, Documento.CodigoBarras)" title="Editar Volumen">
                              <i class="fas fa-pen-square"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                  </div>
                  <div v-if="Documento.Incidentes!=null && Documento.Incidentes.length>0">
                    <div>
                      <h6>Incidentes</h6>
                    </div>
                    <div id="Incidentes_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo Incidente</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Incidentes.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                            <td width="50">{{detalle.NumeroIncidente}}</td>
                            <td width="280">{{detalle.TipoIncidente}}</td>
                            <td width="100">{{detalle.Contenedor}}</td>
                            <td width="400" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                            <td width="400" v-else>{{detalle.Area.Nombre}}</td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(detalle, null)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-if="Documento.Tercerias.length>0">
                    <div>
                      <h6>Tercerías</h6>
                    </div>
                    <div id="Tercerias_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                      <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-dark">
                          <tr>
                            <th>No.</th>
                            <th>Tipo Terceria</th>
                            <th>Caja</th>
                            <th>Ubicacion</th>
                            <th>Estatus</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="text-dark">
                          <tr v-if="Documento.Tercerias.length <= 0">
                            <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                          </tr>
                          <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                            <td width="50">{{detalle.NumeroTerceria}}</td>
                            <td width="280">{{detalle.TipoTerceria}}</td>
                            <td width="100">{{detalle.Contenedor}}</td>
                            <td width="400" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                            <td width="400" v-else>{{detalle.Area.Nombre}}</td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                              <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                              <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                              <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                            </td>
                            <td width="30">
                              <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarIncidente(null, detalle)" title="Editar Incidente">
                                <i class="fas fa-pen-square"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
            </div>
          </div>
          <div class="area" v-if="Documento.TipoDocumento.TipoDocumentoId==4">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-8" id="Area_div">
                <label>Área</label>
                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="TipoDocumento_div">
                <label>Tipo de Documento</label>
                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Anio_div">
                <label>Año</label>
                <input type="text" class="form-control " v-model="Documento.Anio" readonly />
              </div>
              <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-else>
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-4" id="Registro_div">
                <label>Registro de creación</label>
                <input type="text" class="form-control" v-model="FechaCreacion" readonly />
              </div>

            </div>
            <div class="row align-items-center" v-if="Documento.AmparoDocumentoPrincipal!=null">
              <div class="form-group col-12" id="Estatus_div">
                <label class="text-success"><b>Amparo del Documento {{Documento.AmparoDocumentoPrincipal.TipoDocumento.Nombre}} {{Documento.AmparoDocumentoPrincipal.Consecutivo}}/{{Documento.AmparoDocumentoPrincipal.Anio}} del {{Documento.AmparoDocumentoPrincipal.Area.Nombre}}</b></label>
              </div>
            </div>
            <div>
              <div id="Amparos_table" class="table-responsive" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Volumenes.length>0">
                    <table class="table table-striped table-light table-hover table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th>Contenedor</th>
                          <th>Ubicación</th>
                          <th>Estatus</th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr v-if="Documento.Volumenes.length <= 0">
                          <td colspan="12" class="text-center">No hay registro del Volumen</td>
                        </tr>
                        <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                          
                          <td width="50">{{detalle.Contenedor}}</td>
                          <td width="250" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                          <td width="250" v-else>{{detalle.Area.Nombre}}</td>
                        
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                            <span class="badge badge-pill badge-success text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                            <span class="badge badge-pill badge-warning text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          <td width="100" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                            <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                          </td>
                          
                          <td width="30">
                            <a v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4" v-on:click="EditarVolumen(detalle.VolumenId, Documento.CodigoBarras)" title="Editar Volumen">
                              <i class="fas fa-pen-square"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
              </div>
            </div>
          </div>
          <div class="area" v-if="(Documento.TipoDocumento.TipoDocumentoId==5 || Documento.TipoDocumento.TipoDocumentoId==6 || Documento.TipoDocumento.TipoDocumentoId==11 || Documento.TipoDocumento.TipoDocumentoId==12)">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-8" id="Area_div">
                <label>Área</label>
                <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
              </div>
              <div class="form-group col-4" id="TipoDocumento_div">
                <label>Tipo de Documento</label>
                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Anio_div">
                <label>Año</label>
                <input type="text" class="form-control " v-model="Documento.Anio" readonly />
              </div>
              <div class="form-group col-4" id="Consecutivo_div" v-if="Documento.Sufijo==null">
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-2" id="Consecutivo_div" v-else>
                <label>Consecutivo</label>
                <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
              </div>
              <div class="form-group col-4" id="Registro_div">
                <label>Registro de creación</label>
                <input type="text" class="form-control" v-model="FechaCreacion" readonly />
              </div>
            </div>
          </div>
          <div class="area" v-if="IncidenteInfo!=null && (IncidenteInfo.IncidenteId>0 || IncidenteInfo.DocumentoId_Referencia>0)">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Area_div">
                <label>Incidente No:</label>
                <input type="text" class="form-control" v-model="IncidenteInfo.NumeroIncidente" readonly />
              </div>
              <div class="form-group col-8" id="TipoDocumento_div">
                <label>Tipo de Incidente</label>
                <input type="text" class="form-control" v-model="IncidenteInfo.TipoIncidente" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-12" id="Area_div">
                <h6 class="text-success"><b>Incidente del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} del {{Documento.Area.Nombre}}</b></h6>
                
              </div>
            </div>
          </div> 
          <div class="area" v-if="TerceriaInfo!=null && TerceriaInfo.TerceriaId>0">
            <div>
              <h5>Información Principal</h5>
              <hr>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-4" id="Area_div">
                <label>Tercería No:</label>
                <input type="text" class="form-control" v-model="TerceriaInfo.NumeroTerceria" readonly />
              </div>
              <div class="form-group col-8" id="TipoDocumento_div">
                <label>Tipo de Tercería:</label>
                <input type="text" class="form-control" v-model="TerceriaInfo.TipoTerceria" readonly />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="form-group col-12" id="Area_div">
                <h6 class="text-success"><b>Tercería del {{Documento.TipoDocumento.Nombre}} {{Documento.Consecutivo}}/{{Documento.Anio}} del {{Documento.Area.Nombre}}</b></h6>
                
              </div>
            </div>
          </div>
        </div>
      </div>
       <div v-if="this.ModalRef==true">
        <DocumentoDeReferencia :DatosReferencia= this.ReferenciaDoc @dialogo='EstatusModal($event)'>
        </DocumentoDeReferencia>
      </div >
      <div v-if="modalIncidente==true">
        <editIncidente :Incidente = this.IncidenteAEditar :Terceria= this.TerceriaAEditar :Codigo = this.Documento.CodigoBarras :usrArchivo = this.userModal @dialogo='IncidenteModal($event)' ></editIncidente>
      </div>
      <div v-if="this.ModalPrincipal==true">
        <principal :Datos= this.InfoDoc @estado='EstatusPrincipal($event)'></principal>
      </div >
    </div>
    
  </div>

</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import Documento_Referencia from '@/components/ArchivoJudicial/Comun/ReferenciaModal.vue'
import PrincipalDoc from '@/components/ArchivoJudicial/Inventario/infoDocumentoPrincipal.vue'
import IncidenteEdicion from '@/components/ArchivoJudicial/Comun/EditaIncidente.vue'

export default {
    components:{
        Busqueda: FiltroDeBusqueda,
        DocumentoDeReferencia: Documento_Referencia,
        principal: PrincipalDoc,
        editIncidente: IncidenteEdicion
    },
    data(){
        return{
            enumeraciones,
            Documento: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                CodigoBarras: "",
                FechaRegistro: null,
                FechaRegistroArchivo: null,
                TipoEstatusInventario: {},
                SedeArchivo:{},
                Volumenes :[],
                Partes: [],
                Referencias: [],
                Juicio: {},
                BaseDatos: {}
                },
            InfoDoc :{
                InventarioDocumentoId: 0,
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
            },
            IncidenteInfo: {},
            TerceriaInfo: {},
            ReferenciaDoc: [],
            ActualizaConsulta:{
                type: Boolean,
                default: false,
            },
            FechaCreacion: null,
            FechaArchivado: null,
            ModalRef: false,
            AddModalRef: false,
            ModalPrincipal: false,
            AreaConsulta:{},
            modalIncidente :false,
            IncidenteAEditar :{},
            TerceriaAEditar: {},
            userModal: {},
            CodigoARecibir: "",
            PorRecibir : []
        }
    },
    props: {
        barraCode: {
            type: String,
            default: ""
        },
        RegresoInventario: false
    },
    methods:{
        VerInfoDoc(){
          this.ModalPrincipal = true;
        },
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        ObtenDatos(datos){
          this.PorRecibir = [];
          let InfoObtenida = datos;
          if(InfoObtenida.DocumentoConsulta.Anexos!=null)
                {
                    InfoObtenida.DocumentoConsulta.Volumenes[0].AnexosVolumen=InfoObtenida.DocumentoConsulta.Anexos;
                }
          let _this = this;
            //sobre registro en archivo
            switch(this.AreaConsulta.Area.AreaId)
            {
              case 21:
                if(InfoObtenida.DocumentoConsulta.FechaRegistroArchivo != null)
                  {
                    this.Documento = InfoObtenida.DocumentoConsulta;
                    
                    this.InfoDoc = InfoObtenida.DocumentoReferenciado !=null? InfoObtenida.DocumentoReferenciado : null;
                    this.IncidenteInfo = InfoObtenida.InfoIncidente !=null ? InfoObtenida.InfoIncidente: null;
                    this.TerceriaInfo = InfoObtenida.InfoTerceria !=null ? InfoObtenida.InfoTerceria : null;
                    this.userModal = InfoObtenida.UserId;
                    this.FechaCreacion = this.Documento!=null? moment(this.Documento.FechaRegistro).format("DD-MM-YYYY"): null;
                    this.FechaArchivado = this.Documento!=null? moment(this.Documento.FechaRegistroArchivo).format("DD-MM-YYYY"):null;
                    
                    if(this.Documento.Referencias.length > 0)
                    {
                      comun.mensajeDeAlerta("Este Documento tiene Referencia.", null, null);
                    };
                    if(InfoObtenida.DocumentoConsulta.SolicitudActualTramite!=null)
                    {
                      comun.mensajeDeAlerta('</br><label class="text-warning">Este documento tiene una solicitud de prestamo en tramite.</label></br>Solicitado el: '  + this.obtenFechaConFormato(datos.DocumentoConsulta.SolicitudActualTramite.FechaRegistro), null, null);
                    };
                    this.PorRecibir= this.AlertaRecepcion(InfoObtenida.DocumentoConsulta.Volumenes);
                    if(this.PorRecibir.length>0)
                    {
                      comun.mensajeDeAlerta('</br><label class="text-warning">Este documento esta en proceso de Recepción por : ' + this.PorRecibir[0].Ubicacion + '.</label></br>Enviado el: '  + this.PorRecibir[0].FechaEnvio, null, null);
                    }
                  }
                else
                {
                  bootbox.confirm({
                      title: "Mensaje del sistema",
                      message: "No es posible consultar un Documento no Registrado en Archivo</br>" + "Desea registrar el Documento en el Archivo?",
                      buttons: {
                      cancel: {
                          label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                      },
                      confirm: {
                          label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                      }
                    },
                  callback: (respuestaSalir) => {
                        if (respuestaSalir) {
                          this.MovimientoPorRecepcion(InfoObtenida.DocumentoConsulta);
                          
                            this.Documento = InfoObtenida.DocumentoConsulta;
                            this.InfoDoc = InfoObtenida.DocumentoReferenciado !=null? InfoObtenida.DocumentoReferenciado : null;
                            this.IncidenteInfo = InfoObtenida.InfoIncidente !=null ? InfoObtenida.InfoIncidente: null;
                            this.TerceriaInfo = InfoObtenida.InfoTerceria !=null ? InfoObtenida.InfoTerceria : null;
                            this.userModal = InfoObtenida.UserId;
                            this.FechaCreacion = this.Documento.FechaRegistro!=null? moment(this.Documento.FechaRegistro).format("DD-MM-YYYY"): null;
                            this.FechaArchivado = this.Documento.FechaRegistroArchivo!=null? moment(this.Documento.FechaRegistroArchivo).format("DD-MM-YYYY"):null;
                    
                            if(this.Documento.Referencias.length > 0)
                            {
                              comun.mensajeDeAlerta("Este Documento tiene Referencia.", null, null);
                            };
                          
                        }
                      }
                  }); 
                };
                break;
              default:
                if(this.AreaConsulta.Area.AreaId==InfoObtenida.DocumentoConsulta.Area.AreaId)
                {
                  this.Documento = InfoObtenida.DocumentoConsulta;
                  this.InfoDoc = InfoObtenida.DocumentoReferenciado;
                  this.IncidenteInfo = InfoObtenida.InfoIncidente !=null ? InfoObtenida.InfoIncidente: null;
                  this.TerceriaInfo = InfoObtenida.InfoTerceria !=null ? InfoObtenida.InfoTerceria : null;
                  this.FechaCreacion = moment(this.Documento.FechaRegistro).format("DD-MM-YYYY");
                  if(this.Documento.FechaRegistroArchivo!=null)
                  {
                    this.FechaArchivado = moment(this.Documento.FechaRegistroArchivo).format("DD-MM-YYYY");
                  }
                  if(this.Documento.Referencias.length > 0)
                  {
                    comun.mensajeDeAlerta("Este Documento tiene Referencia.", null, null);
                  };
                }
                else
                {
                  comun.mensajeDeAlerta("No es posible consultar un Documento de un Área Distinta.", null, null);
                };
                break;
            };
        },
        EditarVolumen: function (volumen, codigo) {
          bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea editar el Volumen?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Editar'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
                       router.push({name: "AddEditVolumen", params: {volumenId: volumen, CodigoId: codigo}});
                    }
                }
            });
        },
        EditaDocumento: function (codigo){
                bootbox.confirm({
                title: "Mensaje del sistema",
                message: "¿Desea editar el Documento?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Editar'
                    }
                },
                callback: function (respuesta) {
                    if (respuesta) {
                      
                    router.push({name: "EditDocumento", params: {barraCodeEdit: codigo}}); //, params: {volumenId: volumen, CodigoId: codigo}});
                    }
                }
            });
        },
        NuevoVolumen: function (inventario, codigo){
            bootbox.confirm({
            title: "Mensaje del sistema",
            message: "¿Desea agregar un nuevo Volumen?",
            buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Agregar'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
                router.push({name: "AddEditVolumen", params: {documentoId: inventario, CodigoId: codigo}});
            }
          }
            });
        },
        VaciaDatos(){
            this.Documento.InventarioDocumentoId = "";
            this.Documento.Area = "";
            this.Documento.Materia = "";
            this.Documento.TipoDocumento = "";
            this.Documento.Año = "";
            this.Documento.Consecutivo = "";
            this.Documento.CodigodeBarras = "";
            this.Documento.Fecha_Registro = "";
            this.Documento.Estatus = "";
            this.Volumenes = [];
            this.Partes = [];
        },
        VerReferencia(referencias){
          this.ReferenciaDoc = referencias;
          this.ModalRef = true;
        },
        AddEstatusModal(valor){
            this.AddModalRef = valor;
        },
        EstatusModal(valor){
            this.ModalRef = valor;
        },
        IncidenteModal(valor){
          this.modalIncidente = valor.Estatus;
          if(valor.Actualizacion ==true)
          { 
            this.ActualizaConsulta = true;
            this.CodigoARecibir=this.Documento.CodigoBarras

          }
          else
          {
            this.ActualizaConsulta= false;
          }
        },
        AgregaReferencia(){
          this.AddModalRef = true;
        },
        EstatusPrincipal(valor){
          this.ModalPrincipal = valor;
        },
        DesglosaContenido: function (datos){
            let Contenido ="";
            if(datos.NumVolumen==1)
            {
              if(datos.Amparos!= null && datos.Amparos.length>0)
              {
                Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                      $.each(datos.Amparos, function(index, enVolumen)
                      {
                      Contenido = Contenido + "Consecutivo: "+ enVolumen.AmparosDelDocumento.Consecutivo + "/" + enVolumen.AmparosDelDocumento.Anio + "<br/>";
                      })
              };
              if(datos.IncidenteVolumen!= null && datos.IncidenteVolumen.length>0)
                {
                  Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                    $.each(datos.IncidenteVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    })
              };
              if(datos.AnexosVolumen!=null)
              {
                  Contenido= Contenido + "<b class='text-primary'>OBSERVACIONES</b><br/>" + datos.AnexosVolumen
              }
            }
            
            return Contenido;
        },
        EditarIncidente(incidente, terceria){
          this.IncidenteAEditar = incidente;
          this.TerceriaAEditar = terceria;
          this.modalIncidente = true;
          this.CodigoARecibir = "";
          this.ActualizaConsulta = false;
        },
        MovimientoPorRecepcion(datos){
          let Resultado;
          let Movimientos = [];
          if(datos.Volumenes!=null)
          {
            $.each(datos.Volumenes, function(index, movimientos)
            {
              Movimientos.push({
                "VolumenId": movimientos.VolumenId!=null ? movimientos.VolumenId: null ,
                                "IncidenteId": movimientos.IncidenteId!=null ? movimientos.IncidenteId: null,
                                "TerceriaId": movimientos.TerceriaId!=null ? movimientos.TerceriaId: null,
                                "TiposMovimientos": {"TipoMovimientoId": 1},
                                "UsuarioQuienPresta" :{"IdUsuario":null},
                                "UsuarioQuienRecibe" :{"IdUsuario": null},
                                "AreaQuePresta": {"AreaId": movimientos.MovimientoVolumen!=null? movimientos.MovimientoVolumen.AreaQueRecibe.AreaId : movimientos.Area.AreaId},
                                "AreaQueRecibe": {"AreaId": 21},
                                "AreaExterna": null,
                                "SolicitudDocumentoId" : null,
                                "FechaRecepcion": null,
                                "ListaAcuerdo": null,
                                "Observaciones" : "Documento Enviado a Archivo por Correción de ubicación y registro"
              })
            });
          };
          if(datos.Incidentes!=null)
          {
            $.each(datos.Incidentes, function(index, movimientos)
            {
              Movimientos.push({
                "VolumenId": movimientos.MovimientoIncidente.VolumenId!=null ? movimientos.MovimientoIncidente.VolumenId: null ,
                                "IncidenteId": movimientos.MovimientoIncidente.IncidenteId!=null ? movimientos.MovimientoIncidente.IncidenteId: null,
                                "TerceriaId": movimientos.MovimientoIncidente.TerceriaId!=null ? movimientos.MovimientoIncidente.TerceriaId: null,
                                "TiposMovimientos": {"TipoMovimientoId": 1},
                                "AreaQuePresta": {"AreaId": movimientos.MovimientoIncidente!=null? movimientos.MovimientoIncidente.AreaQueRecibe.AreaId : movimientos.Area.AreaId},
                                "AreaQueRecibe": {"AreaId": 21},
                                "AreaExterna": null,
                                "SolicitudDocumentoId" : null,
                                "FechaRecepcion": null,
                                "ListaAcuerdo": null,
                                "Observaciones" : "Documento Enviado a Archivo por Correción de ubicación y registro"
              })
            });
          };
          if(datos.Tercerias!=null)
          {
            $.each(datos.Tercerias, function(index, movimientos)
            {
              Movimientos.push({
                "VolumenId": movimientos.MovimientoTerceria.VolumenId!=null ? movimientos.MovimientoTerceria.VolumenId: null ,
                                "IncidenteId": movimientos.MovimientoTerceria.IncidenteId!=null ? movimientos.MovimientoTerceria.IncidenteId: null,
                                "TerceriaId": movimientos.MovimientoTerceria.TerceriaId!=null ? movimientos.MovimientoTerceria.TerceriaId: null,
                                "TiposMovimientos": {"TipoMovimientoId": 1},
                                "AreaQuePresta": {"AreaId": movimientos.MovimientoTerceria!=null? movimientos.MovimientoTerceria.AreaQueRecibe.AreaId : movimientos.Area.AreaId},
                                "AreaQueRecibe": {"AreaId": 21},
                                "AreaExterna": null,
                                "SolicitudDocumentoId" : null,
                                "FechaRecepcion": null,
                                "ListaAcuerdo": null,
                                "Observaciones" : "Documento Enviado a Archivo por Correción de ubicación y registro"
              })
            });
          }
          var peticion = {Movimientos, "InventarioId": datos.InventarioDocumentoId};
          
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.RecepcionRegistro, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
          if(respuesta.data.SiHayError)
            {
              
              console.log(respuesta);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              
            }
            else
            { 
              comun.SeEstaCargandoInformacion(false);

              comun.mensajeDeAlerta("Se Registrado el de Documento en el Archivo.");
              $.each(this.Documento.Volumenes, function(id, vol)
              {
                vol.Area.AreaId = 21;
                vol.Area.Nombre = "Archivo Judicial"
                vol.EstatusVolumenes.TipoEstatusVolumenId = 1;
                vol.EstatusVolumenes.Nombre = "Disponible"
              });
              $.each(this.Documento.Incidentes, function(id, Inc)
              {
                Inc.Area.AreaId = 21;
                Inc.Area.Nombre = "Archivo Judicial"
                Inc.EstatusVolumenes.TipoEstatusVolumenId = 1;
                Inc.EstatusVolumenes.Nombre = "Disponible"
              });
              $.each(this.Documento.Tercerias, function(id, Ter)
              {
                Ter.Area.AreaId = 21;
                Ter.Area.Nombre = "Archivo Judicial"
                Ter.EstatusVolumenes.TipoEstatusVolumenId = 1;
                Ter.EstatusVolumenes.Nombre = "Disponible"
              })
              
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
          
        },
        AlertaRecepcion: function(datos)
        {
          let arrayTemporal = [];
          if(datos!=null)
          {
            if(datos[0].MovimientoVolumen!=null)
            {
              if(datos[0].MovimientoVolumen.FechaRecepcion==null)
              {
                arrayTemporal.push({
                  Ubicacion: datos[0].MovimientoVolumen.AreaQueRecibe.Nombre,
                  FechaEnvio : this.obtenFechaConFormato(datos[0].MovimientoVolumen.FechaMovimiento)
                })
              }
            }
          }
          return arrayTemporal;
        },
        EstatusUbicacionVolumen: function (datos)
        {
          let detalles ="";
          if(datos.MovimientoVolumen!=null)
          {
            if(datos.MovimientoVolumen.FechaRecepcion==null)
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + (datos.MovimientoVolumen.AreaQuePresta!=null ? datos.MovimientoVolumen.AreaQuePresta.Nombre : '') + '<br>';
              detalles = detalles + 'En proceso de recepción por :<br>'; 
              detalles = detalles + (datos.MovimientoVolumen.AreaQueRecibe!=null ? datos.MovimientoVolumen.AreaQueRecibe.Nombre : '')+ '<br>';
              detalles = detalles + 'Fecha de Envio: ' + this.obtenFechaConFormato(datos.MovimientoVolumen.FechaMovimiento) + '<br>';
              if(datos.MovimientoVolumen.SolicitudDocumentoId!=null)
              {
                detalles = detalles + "Solicitud de Prestamo # " + datos.MovimientoVolumen.SolicitudDocumentoId;
              };
              
            }
            else
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + datos.MovimientoVolumen.AreaQueRecibe.Nombre + '<br>';
              detalles = detalles + 'Fecha de Recepción: ' + this.obtenFechaConFormato(datos.MovimientoVolumen.FechaRecepcion) + '<br>';
            };
          }
          else
          {
            detalles = detalles + 'Ubicación: ' + '<br>';
            detalles = detalles + datos.Area.Nombre + '<br>';
          }
          return detalles;
        },
        EstatusUbicacionIncidente: function (datos)
        {
          let detalles ="";
          if(datos.MovimientoIncidente!=null)
          {
            if(datos.MovimientoIncidente.FechaRecepcion==null)
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + (datos.MovimientoIncidente.AreaQuePresta!=null ? datos.MovimientoIncidente.AreaQuePresta.Nombre : '') + '<br>';
              detalles = detalles + 'En proceso de recepción por :<br>'; 
              detalles = detalles + (datos.MovimientoIncidente.AreaQueRecibe!=null ? datos.MovimientoIncidente.AreaQueRecibe.Nombre : '') + '<br>';
              detalles = detalles + 'Fecha de Envio: ' + this.obtenFechaConFormato(datos.MovimientoIncidente.FechaMovimiento) + '<br>';
              if(datos.MovimientoIncidente.SolicitudDocumentoId!=null)
              {
                detalles = detalles + "Solicitud de Prestamo # " + datos.MovimientoIncidente.SolicitudDocumentoId;
              };
              
            }
            else
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + datos.MovimientoIncidente.AreaQueRecibe.Nombre + '<br>';
              detalles = detalles + 'Fecha de Recepción: ' + this.obtenFechaConFormato(datos.MovimientoIncidente.FechaRecepcion) + '<br>';
            };
          }
          else
          {
            detalles = detalles + 'Ubicación: ' + '<br>';
            detalles = detalles + datos.Area.Nombre + '<br>';
          }
          return detalles;
        },
        EstatusUbicacionTerceria: function (datos)
        {
          let detalles ="";
          if(datos.MovimientoTerceria!=null)
          {
            if(datos.MovimientoTerceria.FechaRecepcion==null)
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + (datos.MovimientoTerceria.AreaQuePresta!=null ? datos.MovimientoTerceria.AreaQuePresta.Nombre : '') + '<br>';
              detalles = detalles + 'En proceso de recepción por :<br>'; 
              detalles = detalles + (datos.MovimientoTerceria.AreaQueRecibe!=null ? datos.MovimientoTerceria.AreaQueRecibe.Nombre : '') + '<br>';
              detalles = detalles + 'Fecha de Envio: ' + this.obtenFechaConFormato(datos.MovimientoTerceria.FechaMovimiento) + '<br>';
              if(datos.MovimientoTerceria.SolicitudDocumentoId!=null)
              {
                detalles = detalles + "Solicitud de Prestamo # " + datos.MovimientoTerceria.SolicitudDocumentoId;
              };
              
            }
            else
            {
              detalles = detalles + 'Ubicación: ' + '<br>';
              detalles = detalles + datos.MovimientoTerceria.AreaQueRecibe.Nombre + '<br>';
              detalles = detalles + 'Fecha de Recepción: ' + this.obtenFechaConFormato(datos.MovimientoTerceria.FechaRecepcion) + '<br>';
            };
          }
          else
          {
            detalles = detalles + 'Ubicación: ' + '<br>';
            detalles = detalles + datos.Area.Nombre + '<br>';
          }
          return detalles;
        }

    }, 
    mounted(){
      this.AreaConsulta = this.$store.state.Login_Usuario;
    }
}
</script>

<style scoped>
  input[type="text"]:read-only {
    background: #504f54;
  }

    input[type="text"]:read-only:focus {
      color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/Inventario.vue